import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PlayList } from '@app/components/widget/playlist/playlist.component';
import { GlobalFunctionService } from '@app/system/services/global-function.service';

@Component({
	selector: 'app-playlist-queue',
	templateUrl: './playlist-queue.component.html',
	styleUrls: ['./playlist-queue.component.scss']
})
export class PlaylistQueueComponent implements OnInit {

	@Input() playList: Array<PlayList>;
	@Input() actionType = '';
	@Output() emitData: any = new EventEmitter();

	constructor(
		public gfService: GlobalFunctionService
	) { }

	ngOnInit(): void {
	}

	selectData(data, index) {
		if (navigator.onLine) {
			this.playList.forEach((event: any) => {
				event.streaming = false;
			});
			data.streaming = true;
			this.emitData.emit({ selectedData: data, selectedIndex: index });
		}
	}

}
